import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { ThreeDots } from "react-loader-spinner";
import { toggleMenu } from "../../utils/helpers";
import Footer from "../../components/Footer";
import PageTitle from "../../components/PageTitle";
import "../../Styles/style.css";
import "../../Styles/projectMemberForm.css";
import SortableTable from "../../components/SortableTable";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";
import { getApi } from "../../utils/api";
import Select from "react-select";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import axios from "axios";
import {
  findProjectDesignationOption,
  useProjectDesignationOptions,
} from "../../Hooks/useProjectDesignationOptions";
import { designationOptionsForType, projectDesignationTypeOptions } from "../../Hooks/projectDesignationTypes";
import { performanceLensRoleSelectOptions } from "../../Hooks/performanceLensRoleOptions";
import { Select as V2Select } from "../../v2/components/ui/select/select.tsx";
import CharLimitTextArea from "../../components/Performance/CharLimitTextArea";
import TeamMembersNotificationModal from "../../components/ProjectManagement/TeamMembersNotificationModal";
import ProjectMemberHistoryDrawer from "../../components/ProjectManagement/ProjectMemberHistoryDrawer";
import DepartmentProjectAccess from "../../components/ProjectManagement/DepartmentProjectAccess";
import ProjectStatusSummary from "../../components/ProjectManagement/ProjectStatusSummary";
import { formatToDateOnly } from "../../utils/helpers";
import { displayFormatDate } from "../../utils/helpers";
import {
  MdKeyboardArrowDown,
  MdOutlineEmail,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import { projectTypeOptions } from "../../options/projectTypesOptions";
import {
  API_PROJECT_LIST,
  API_PROJECT_TEAM,
  EMPLOYEE_LIST,
  API_ASSIGN_PROJECT_MEMBERS,
  API_PROJECT_ASSIGNMENT_HR_POCS,
  API_PROJECT_ASSIGNMENT_NOTIFY_HR,
  API_EDIT_PROJECT_MEMBERS,
  API_DELETE_PROJECT_MEMBERS,
  API_LEAVE_GET_OOD_DL_LIST,
  API_EDIT_PROJECT_DETAILS,
  API_GET_PRINCIPAL_SPONSOR_LIST,
  API_GET_PROJECT_MANAGER_LIST,
  API_GET_LEAD_BUSINESS_ANALYST_LIST,
  API_GET_HEAD_OF_DELIVERY_LIST,
  API_GET_PROGRAM_MANAGER_LIST,
  API_SQE_PROJECT_LEAD_MEMBERS,
  API_PROJECT_COMPLETE_NOTIFICATION,
  API_PROJECT_EXPERTIES,
} from "../../config/Endpoints";
import ProjectListDetails from "../../components/ProjectManagement/ProjectListDetails";
import projectStatusOptions from "../../options/projectStatusOptions";
import ProjectCompleteNotificationModal from "../../components/ProjectManagement/ProjectCompletedNotificationModal";
import ProjectHoldToActiveModal from "../../components/ProjectManagement/ProjectHoldToActiveModal";
import LeadershipEffectiveDateModal from "../../components/ProjectManagement/LeadershipEffectiveDateModal";
import {useUser} from "../../v2/lib/rbac/useUser.ts";
import { useSqeLabs } from "../../v2/hooks/use-sqe-labs.ts";
import { useSqeEmployeeNameOptions } from "../../v2/hooks/use-sqe-employee-name-options.ts";
import { getSqeProjectLeadOptions } from "./sqeProjectLeadOptions";

const needsApprovalOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const trackableOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const timesheetAccessOptions = [
  { value: "ASSIGNED_ONLY", label: "Assigned members only" },
  { value: "GLOBAL", label: "All eligible employees" },
  { value: "DEPARTMENT", label: "Selected employees" },
];

const leadershipFields = [
  { role: "DELIVERY_LEAD", field: "dlId", nameField: "dlName", label: "Delivery Lead" },
  { role: "PROJECT_MANAGER", field: "projectManagerId", nameField: "projectManagerName", label: "Project Manager" },
  { role: "HEAD_OF_DELIVERY", field: "hodId", nameField: "hodName", label: "Head of Delivery" },
  { role: "PROGRAM_MANAGER", field: "programManagerId", nameField: "programManagerName", label: "Program Manager" },
  { role: "PRINCIPAL_SPONSOR", field: "principalSponsorId", nameField: "principalSponsorName", label: "Principal Sponsor" },
  { role: "LEAD_BUSINESS_ANALYST", field: "leadBusinessAnalyst", nameField: "leadBusinessAnalystName", label: "Lead Business Analyst" },
];

const normalizedMemberId = (value) => value == null || value === "" ? null : String(value);
const changedLeadershipMembers = (project, original) => !original ? [] : leadershipFields
  .filter(({ field }) => normalizedMemberId(project?.[field]) !== normalizedMemberId(original?.[field]))
  .map(({ role, field, nameField, label }) => ({ role, label, previousId: original?.[field] ?? null, nextId: project?.[field] ?? null, previousName: original?.[nameField] ?? null, nextName: project?.[nameField] ?? null }));

const toOptionalId = (value) => {
  if (value == null || value === "") return null;
  const id = Number(value);
  return Number.isNaN(id) ? null : id;
};

function SqeEditLeadField({ isSqeLabs, options, children }) {
  if (isSqeLabs && options.length === 1) {
    return <input type="text" className="form-control" value={options[0].label} readOnly />;
  }
  return children;
}

const findDesignationOption = findProjectDesignationOption;

const normalizeDesignationValue = (designation) => {
  const option = findDesignationOption(designation);

  return option
    ? option.value
    : String(designation || "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
};

const isQaOrTesterDesignation = (designation) => {
  const value = String(designation || "").trim().toUpperCase();
  return (
    /\bQA\b/.test(value) ||
    value.includes("TESTER") ||
    value.includes("QUALITY ASSURANCE") ||
    value.includes("TEST ENGINEER")
  );
};

const hasConfiguredTechStack = (techStack) => {
  const value = String(techStack || "")
    .trim()
    .replace(/[\s_-]+/g, "")
    .toUpperCase();
  return value !== "" && value !== "NOTASSIGNED" && value !== "NULL";
};

const mapProject = (project, existingProject = {}) => ({
  ...existingProject,
  ...project,
  id: project.projectId ?? existingProject.id,
  projectName:
    project.projectName || existingProject.projectName || "Untitled Project",
  projectType: project.projectType ?? existingProject.projectType,
  startDate: project.startDate ?? existingProject.startDate ?? null,
  endDate: project.endDate ?? existingProject.endDate ?? null,
  sowStartDate: project.sowStartDate ?? existingProject.sowStartDate ?? null,
  sowEndDate: project.sowEndDate ?? existingProject.sowEndDate ?? null,
  commercialSummary:
    project.commercialSummary ??
    existingProject.commercialSummary ??
    "-",
  dlId: project.dl?.id ?? project.dlId ?? existingProject.dlId ?? null,
  dlName: project.dl?.name ?? project.dlName ?? existingProject.dlName,
  projectManagerId:
    project.pm?.id ??
    project.projectManagerId ??
    existingProject.projectManagerId ??
    null,
  projectManagerName:
    project.pm?.name ??
    project.projectManagerName ??
    existingProject.projectManagerName,
  principalSponsorId:
    project.ps?.id ??
    project.principalSponsorId ??
    existingProject.principalSponsorId ??
    null,
  principalSponsorName:
    project.ps?.name ??
    project.principalSponsorName ??
    existingProject.principalSponsorName,
  programManagerId: toOptionalId(
    project.programManager?.id ??
      project.programManagerId ??
      existingProject.programManagerId,
  ),
  programManagerName:
    project.programManager?.name ??
    project.programManagerName ??
    existingProject.programManagerName,
  leadBusinessAnalyst:
    project.lba?.id ??
    project.leadBusinessAnalyst ??
    existingProject.leadBusinessAnalyst ??
    null,
  leadBusinessAnalystName:
    project.lba?.name ??
    project.leadBusinessAnalystName ??
    existingProject.leadBusinessAnalystName,
  hodId: project.hod?.id ?? project.hodId ?? existingProject.hodId ?? null,
  hodName: project.hod?.name ?? project.hodName ?? existingProject.hodName,
  workstreams: Array.isArray(project.workstreams)
    ? project.workstreams
        .map((workstream) =>
          typeof workstream === "string"
            ? workstream
            : workstream?.workstream,
        )
        .filter(Boolean)
    : existingProject.workstreams || [],
  needsApproval:
    project.needsApproval !== undefined
      ? project.needsApproval
      : existingProject.needsApproval ?? null,
  trackable:
    project.trackable !== undefined
      ? Boolean(project.trackable)
      : existingProject.trackable ?? false,
  timesheetAccessMode:
    project.timesheetAccessMode ?? existingProject.timesheetAccessMode ?? "ASSIGNED_ONLY",
  iscreatedPush: project.iscreatedPush ?? existingProject.iscreatedPush,
  projectStatus: project.status ?? existingProject.projectStatus ?? 0,
  members: Array.isArray(project.members)
    ? project.members.map((member) => ({
        ...member,
        id: member.id,
        name: member.employeeName ?? member.fullName ?? member.name ?? "",
        designation: member.designation,
        joinDate: member.createdDate ?? member.joinDate ?? null,
        employeeId: member.employeeId,
        endDate: member.endDate ?? null,
        status: member.status,
      }))
    : existingProject.members || [],
});

function ProjectList({ title, description }) {
  const isSqeLabs = useSqeLabs();
  const { options: sqeEmployees } = useSqeEmployeeNameOptions(isSqeLabs);
  const { options: designationOptions, loading: isDesignationLoading } = useProjectDesignationOptions();
  const [projectList, setProjectList] = useState([]);
  const [editingProjectId, setEditingProjectId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState(projectList);
  const [projectStatusFilter, setProjectStatusFilter] = useState("ALL");
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const [employeeList, setEmployeeList] = useState([]);
  const [expertiseOptions, setExpertiseOptions] = useState([]);
  const [isExpertiseLoading, setIsExpertiseLoading] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [hrPocs, setHrPocs] = useState([]);
  const [selectedHrPocIds, setSelectedHrPocIds] = useState([]);
  const [hrPocsLoading, setHrPocsLoading] = useState(false);
  const [notifyHrLoading, setNotifyHrLoading] = useState(false);
  const [hrNotified, setHrNotified] = useState(false);
  const userData = useUser();
  const [deliveryLead, setDeliveryLead] = useState([]);
  const [deleteTarget, setDeleteTarget] = useState({
    employeeId: null,
    projectId: null,
  });
  const [originalProjectData, setOriginalProjectData] = useState(null);
  const [originalMemberData, setOriginalMemberData] = useState(null);
  const [principalSponsors, setPrincipalSponsors] = useState([]);
  const [projectManagers, setProjectManagers] = useState([]);
  const [programManagers, setProgramManagers] = useState([]);
  const [leadBusinessAnalysts, setLeadBusinessAnalysts] = useState([]);
  const [headOfDeliveryList, setHeadOfDeliveryList] = useState([]);
  const [sqeLeadMembers, setSqeLeadMembers] = useState([]);
  const selectableProjectManagers = isSqeLabs
    ? sqeEmployees.map((employee) => ({ value: Number(employee.value), label: employee.label }))
    : projectManagers;
  const deliveryLeadOptions = isSqeLabs ? sqeLeadMembers : deliveryLead;
  const headOfDeliveryOptions = isSqeLabs ? sqeLeadMembers : headOfDeliveryList;
  const programManagerOptions = isSqeLabs ? sqeLeadMembers : programManagers;
  const principalSponsorOptions = isSqeLabs ? sqeLeadMembers : principalSponsors;
  const leadBusinessAnalystOptions = isSqeLabs ? sqeLeadMembers : leadBusinessAnalysts;
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const [showDeallocateModal, setShowDeallocateModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [showConfirmDeallocateModal, setShowConfirmDeallocateModal] =
    useState(false);
  const [openProjectId, setOpenProjectId] = useState(null);
  const [loadingProjectId, setLoadingProjectId] = useState(null);
  const [editableStatus, setEditableStatus] = useState();
  const [showProjectCompletedModal, setShowProjectCompletedModal] =
    useState(false);
  const [pendingCompletedProjectId, setPendingCompletedProjectId] =
    useState(null);
  const [showHoldToActiveModal, setShowHoldToActiveModal] = useState(false);
  const [pendingHoldToActiveProjectId, setPendingHoldToActiveProjectId] =
    useState(null);
  const [holdToActiveDate, setHoldToActiveDate] = useState(null);
  const [holdToActiveLoading, setHoldToActiveLoading] = useState(false);
  const [leadershipDateRequest, setLeadershipDateRequest] = useState(null);
  const [pendingLeadershipDates, setPendingLeadershipDates] = useState(null);
  // const toggleProject = (id) => {
  //   setOpenProjectId(openProjectId === id ? null : id);
  // };
  const fetchProjectTeam = async (id) => {
    setLoadingProjectId(id);
    try {
      const response = await getApi(`${API_PROJECT_TEAM}/${id}`, accessToken);
      const details = response.data?.data ?? response.data;
      if (!details || Array.isArray(details)) return;

      const updateProject = (projects) =>
        projects.map((project) =>
          project.id === id ? mapProject(details, project) : project,
        );
      setProjectList((prev) => updateProject(prev));
      setFilteredItems((prev) => updateProject(prev));
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to load project details",
        { position: toast.POSITION.TOP_RIGHT },
      );
    } finally {
      setLoadingProjectId((currentId) => (currentId === id ? null : currentId));
    }
  };

  const toggleProject = (id) => {
    // If closing the currently open accordion
    if (openProjectId === id) {
      setOpenProjectId(null);
      // Reset edit mode for this project
      if (editingProjectId === id) {
        setEditingProjectId(null);
        setOriginalProjectData(null);
        setPendingLeadershipDates(null);
        setLeadershipDateRequest(null);
        const newEditableStatus = { ...editableStatus };
        delete newEditableStatus[id];
        setEditableStatus(newEditableStatus);
      }
    } else {
      fetchProjectTeam(id);
      // If opening a different accordion, close any open edit form
      if (editingProjectId && editingProjectId !== id) {
        // Restore original data if switching accordions
        if (originalProjectData) {
          const updateProject = (projects) =>
            projects.map((proj) =>
              proj.id === editingProjectId ? originalProjectData : proj
            );
          setProjectList((prev) => updateProject(prev));
          setFilteredItems((prev) => updateProject(prev));
        }
        setEditingProjectId(null);
        setOriginalProjectData(null);
        setPendingLeadershipDates(null);
        setLeadershipDateRequest(null);
      }
      setOpenProjectId(id);
    }
  };
  const [isLoadingCompletedProject, setIsLoadingCompletedProject] =
    useState(false);

  const dealocatedreasonOptions = [
    {
      value: "Project Delivery Completed",
      label: "Project Delivery Completed",
    },
    { value: "Change in Team Size", label: "Change in Team Size" },
    {
      value: "Transition to Managed Services",
      label: "Transition to Managed Services",
    },
    { value: "Resource Reshuffle", label: "Resource Reshuffle" },
  ];

  const hasProjectChanges = (currentProject, originalProject) => {
    if (!originalProject) return false;

    return (
      currentProject.projectType !== originalProject.projectType ||
      currentProject.dlId !== originalProject.dlId ||
      currentProject.startDate !== originalProject.startDate ||
      currentProject.endDate !== originalProject.endDate ||
      currentProject.sowStartDate !== originalProject.sowStartDate ||
      currentProject.sowEndDate !== originalProject.sowEndDate ||
      currentProject.commercialSummary !== originalProject.commercialSummary ||
      currentProject.projectManagerId !== originalProject.projectManagerId ||
      currentProject.programManagerId !== originalProject.programManagerId ||
      currentProject.principalSponsorId !==
        originalProject.principalSponsorId ||
      currentProject.leadBusinessAnalyst !==
        originalProject.leadBusinessAnalyst ||
      currentProject.hodId !== originalProject.hodId ||
      currentProject.needsApproval !== originalProject.needsApproval ||
      currentProject.trackable !== originalProject.trackable ||
      currentProject.timesheetAccessMode !== originalProject.timesheetAccessMode ||
      currentProject.projectStatus !== originalProject.projectStatus
    );
  };

  const beginEditProject = (project) => {
    if (isSqeLabs && sqeLeadMembers.length === 0) {
      toast.error("SQE project lead members are still unavailable. Please try again.");
      return;
    }

    const lead = isSqeLabs && sqeLeadMembers.length === 1 ? sqeLeadMembers[0] : null;
    const editableProject = lead ? {
      ...project,
      dlId: lead.value,
      dlName: lead.label,
      hodId: lead.value,
      hodName: lead.label,
      programManagerId: lead.value,
      programManagerName: lead.label,
      principalSponsorId: lead.value,
      principalSponsorName: lead.label,
      leadBusinessAnalyst: lead.value,
      leadBusinessAnalystName: lead.label,
    } : project;

    setPendingLeadershipDates(null);
    setLeadershipDateRequest(null);
    setOriginalProjectData({ ...project });
    if (lead) {
      setProjectList((projects) => projects.map((item) => item.id === project.id ? editableProject : item));
      setFilteredItems((projects) => projects.map((item) => item.id === project.id ? editableProject : item));
    }
    setEditingProjectId(project.id);
    setEditableStatus((current) => ({ ...current, [project.id]: project.projectStatus }));
  };

  const hasMemberChanges = (currentMember, originalMember) => {
    if (!originalMember) return false;

    return (
      currentMember.designation !== originalMember.designation ||
      currentMember.performanceRoleCode !== originalMember.performanceRoleCode ||
      currentMember.expertise !== originalMember.expertise ||
      currentMember.joinDate !== originalMember.joinDate ||
      currentMember.endDate !== originalMember.endDate ||
      currentMember.status !== originalMember.status
    );
  };

  const handleProjectStatusUpdate = (projectId, projectStatus, pushStatus) => {
    const updateProject = (proj) => {
      if (proj.id !== projectId) return proj;

      const updates = {};

      if (projectStatus !== undefined) {
        updates.projectStatus = projectStatus;
      }

      if (pushStatus !== undefined) {
        updates.iscreatedPush = pushStatus;
      }

      if (projectStatus === 1 || projectStatus === 2 || projectStatus === 3) {
        updates.members = proj.members.map((member) => ({
          ...member,
          status: StatusEnum.DEALLOCATED,
        }));
      }

      return { ...proj, ...updates };
    };

    setProjectList((prev) => prev.map(updateProject));
    setFilteredItems((prev) => prev.map(updateProject));
  };

  const handleEditMember = (member, projectId) => {
    setCurrentProjectId(projectId);
    setEditingMemberId(member.id);
    console.log(member.id);
    setMemberForm({
      name: member.name,
      designation: normalizeDesignationValue(member.designation),
      performanceRoleCode: member.performanceRoleCode || "",
      locationType: findDesignationOption(member.designation)?.locationType || "",
      expertise: member.expertise || "",
      joinDate: member.joinDate,
      endDate: member.endDate,
      status: member.status,
      projectId: projectId,
    });
    setOriginalMemberData({
      name: member.name,
      designation: normalizeDesignationValue(member.designation),
      performanceRoleCode: member.performanceRoleCode || "",
      locationType: findDesignationOption(member.designation)?.locationType || "",
      expertise: member.expertise || "",
      joinDate: member.joinDate,
      endDate: member.endDate,
      status: member.status,
    });

    setSelectedEmployee({ value: member.id, label: member.name });
    setShowMemberModal(true);
  };

  const handleDateChange = (field, value) => {
    const updatedForm = {
      ...memberForm,
      [field]: value || null,
    };

    const project = projectList.find((p) => p.id === currentProjectId);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (updatedForm.status === StatusEnum.DEALLOCATED) {
      setMemberForm(updatedForm);
      return;
    }

    if (updatedForm.endDate) {
      const endDate = new Date(updatedForm.endDate);
      endDate.setHours(0, 0, 0, 0);
      if (endDate > currentDate) {
        updatedForm.status = StatusEnum.ACTIVE;
      } else {
        updatedForm.status = StatusEnum.INACTIVE;
      }
    } else if (updatedForm.joinDate) {
      updatedForm.status = StatusEnum.ACTIVE;
    } else {
      updatedForm.status = "";
    }

    setMemberForm(updatedForm);
  };

  const StatusEnum = {
    ACTIVE: 1,
    INACTIVE: 0,
    DEALLOCATED: 2,
  };

  const StatusOptions = [
    { value: StatusEnum.ACTIVE, label: "Active" },
    { value: StatusEnum.INACTIVE, label: "Inactive" },
    { value: StatusEnum.DEALLOCATED, label: "Deallocated" },
  ];

  const columns = (projectId) => [
    { key: "name", label: "Employee Name" },
    {
      key: "designation",
      label: "Designation",
      render: (item) => {
        const option = findDesignationOption(item.designation);
        return option ? option.label : item.designation || "-";
      },
    },
    {
      key: "expertise",
      label: "Project Expertise",
      render: (item) => item.expertise?.trim() || "-",
    },
    {
      key: "joinDate",
      label: "Joining Date",
      compare: (a, b) => new Date(a.joinDate) - new Date(b.joinDate),
      render: (item) => {
        return displayFormatDate(item.joinDate);
      },
    },
    {
      key: "endDate",
      label: "End Date",
      compare: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      render: (item) => displayFormatDate(item.endDate),
    },
    {
      key: "status",
      label: "Status",
      render: (item) => {
        switch (item.status) {
          case 1:
            return "Active";
          case 0:
            return "Inactive";
          case 2:
            return "Deallocated";
          default:
            return item.status || "-";
        }
      },
    },
    {
      key: "action",
      label: "Action",
      render: (item) => {
        const project = projectList.find((p) => p.id === projectId);
        const isProjectCompleted = [1, 3].includes(project?.projectStatus);
        return (
          <div>
            <a
              href="javascript:void(0)"
              className={`fw-bolder ${
                isProjectCompleted || item.status === StatusEnum.DEALLOCATED
                  ? "text-muted"
                  : ""
              }`}
              onClick={() => {
                if (
                  !isProjectCompleted &&
                  item.status !== StatusEnum.DEALLOCATED
                ) {
                  handleEditMember(item, projectId);
                }
              }}
              style={{
                cursor:
                  isProjectCompleted || item.status === StatusEnum.DEALLOCATED
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Edit
            </a>

            <a
              href="javascript:void(0)"
              className="ms-3 fw-bolder text-danger"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdropDependentDelete"
              onClick={() =>
                setDeleteTarget({ employeeId: item.employeeId, projectId })
              }
              style={{ cursor: "pointer" }}
            >
              Delete
            </a>
          </div>
        );
      },

      sortable: false,
    },
  ];
  const [showMemberModal, setShowMemberModal] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);

  const [memberForm, setMemberForm] = useState({
    name: "",
    designation: "",
    performanceRoleCode: "",
    locationType: "",
    expertise: "",
    joinDate: null,
    endDate: null,
    status: "",
  });
  const [editingMemberId, setEditingMemberId] = useState(null);

  const selectedEmployeeRequiresTechStack = Boolean(
    !editingMemberId &&
      selectedEmployee &&
      !hasConfiguredTechStack(selectedEmployee.techStack) &&
      !isQaOrTesterDesignation(selectedEmployee.currentDesignation),
  );

  useEffect(() => {
    if (!showMemberModal || !editingMemberId || memberForm.locationType || !memberForm.designation) return;
    const option = findDesignationOption(memberForm.designation, designationOptions);
    if (option) {
      setMemberForm((current) => ({ ...current, locationType: option.locationType }));
      setOriginalMemberData((current) => current ? { ...current, locationType: option.locationType } : current);
    }
  }, [showMemberModal, editingMemberId, memberForm.locationType, memberForm.designation, designationOptions]);

  useEffect(() => {
    if (!showMemberModal || !selectedEmployeeRequiresTechStack) {
      setHrPocs([]);
      setSelectedHrPocIds([]);
      setHrPocsLoading(false);
      return;
    }

    let active = true;
    setHrPocsLoading(true);
    getApi(API_PROJECT_ASSIGNMENT_HR_POCS, accessToken)
      .then((response) => {
        if (!active) return;
        const contacts = response.data?.data ?? response.data;
        const configuredContacts = Array.isArray(contacts) ? contacts : [];
        setHrPocs(configuredContacts);
        setSelectedHrPocIds(configuredContacts.map((contact) => contact.id));
      })
      .catch(() => {
        if (active) setHrPocs([]);
      })
      .finally(() => {
        if (active) setHrPocsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [accessToken, selectedEmployeeRequiresTechStack, showMemberModal]);

  const handleSearch = (e) => {
    const searchValue = e.target.value;

    setSearchTerm(searchValue);
    const filtered = projectList.filter((item) =>
      item.projectName.toLowerCase().includes(searchValue.toLowerCase())
    );

    setFilteredItems(filtered);
  };

  const displayedProjects = filteredItems.filter(
    (project) => projectStatusFilter === "ALL" || Number(project.projectStatus) === projectStatusFilter,
  );

  const handleProjectStatusFilter = (status) => {
    setProjectStatusFilter(status);
    setOpenProjectId(null);
    setEditingProjectId(null);
    setOriginalProjectData(null);
  };

  const handleProjectChange = (projectId, field, value, name) => {
    const updateProject = (projects) =>
      projects.map((proj) =>
        proj.id === projectId
          ? {
              ...proj,
              [field]:
                value instanceof Date
                  ? formatToDateOnly(value)
                  : field === "programManagerId"
                    ? toOptionalId(value)
                    : value,
              ...(field === "dlId" && { dlName: name }),
              ...(field === "projectManagerId" && { projectManagerName: name }),
              ...(field === "programManagerId" && { programManagerName: name }),
              ...(field === "principalSponsorId" && {
                principalSponsorName: name,
              }),
              ...(field === "leadBusinessAnalyst" && {
                leadBusinessAnalystName: name,
              }),
              ...(field === "hodId" && { hodName: name }),
            }
          : proj
      );
    setProjectList((prev) => updateProject(prev));
    setFilteredItems((prev) => updateProject(prev));
  };

  const handleUpdateProject = async (
    projectId,
    e = null,
    sendNotification = false,
    withHoldToActiveDate = false,
    holdToActiveDate = null,
    leadershipEffectiveDates = null
  ) => {
    if (e) e.preventDefault();

    const project = projectList.find((p) => p.id === projectId);
    const originalStatus = project.projectStatus;
    const leadershipChanges = changedLeadershipMembers(project, originalProjectData);
    const effectiveLeadershipDates = leadershipEffectiveDates || pendingLeadershipDates;

    if (leadershipChanges.length > 0 && !effectiveLeadershipDates) {
      setLeadershipDateRequest({ projectId, sendNotification, withHoldToActiveDate, holdToActiveDate, changes: leadershipChanges });
      return;
    }
    if (effectiveLeadershipDates) setPendingLeadershipDates(effectiveLeadershipDates);

    if (!project.hodId) {
      toast.error("Head of Delivery is required.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const isChangingToComplete =
      originalProjectData?.projectStatus === 2 && project.projectStatus === 1;

    const isChangingToActive =
      originalProjectData?.projectStatus === 2 && project.projectStatus === 0;

    if (isChangingToActive && !withHoldToActiveDate) {
      setPendingHoldToActiveProjectId(projectId);
      setShowHoldToActiveModal(true);
      return;
    }

    if (isChangingToComplete && !sendNotification) {
      setPendingCompletedProjectId(projectId);
      setShowProjectCompletedModal(true);
      return;
    }

    if (sendNotification) {
      setIsLoadingCompletedProject(true);
    } else if (withHoldToActiveDate) {
      setHoldToActiveLoading(true);
    } else {
      setIsLoadingUpdate(true);
    }

    const toDate = (d) => {
      if (!d) return null;
      const x = new Date(d);
      x.setHours(0, 0, 0, 0);
      return x;
    };

    const payload = {
      projectName: project.projectName,
      projectType: project.projectType,
      status: project.projectStatus,
      deliveryLead: project.dlId,
      startDate: formatToDateOnly(toDate(project.startDate)),
      endDate: formatToDateOnly(toDate(project.endDate)),
      sowStartDate: formatToDateOnly(toDate(project.sowStartDate)),
      sowEndDate: formatToDateOnly(toDate(project.sowEndDate)),
      commercialSummary: project.commercialSummary,
      projectManager: project.projectManagerId,
      programManagerId: toOptionalId(project.programManagerId),
      principalSponsor: project.principalSponsorId,
      leadBusinessAnalyst: project.leadBusinessAnalyst || null,
      hodLead: project.hodId,
      workstreams: project.workstreams || [],
      needsApproval: project.needsApproval ?? false,
      trackable: project.trackable ?? false,
      timesheetAccessMode: project.timesheetAccessMode ?? "ASSIGNED_ONLY",
      holdToActiveDate:
        holdToActiveDate && !isNaN(new Date(holdToActiveDate))
          ? formatToDateOnly(new Date(holdToActiveDate))
          : null,
      leadershipStartDates: effectiveLeadershipDates
        ? Object.fromEntries(Object.entries(effectiveLeadershipDates).map(([role, date]) => [role, formatToDateOnly(new Date(date))]))
        : {},
    };

    try {
      const res = await axios.patch(
        `${API_EDIT_PROJECT_DETAILS}/${projectId}`,
        payload,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (res.status === 200) {
        if (sendNotification) {
          try {
            const notifyRes = await axios.post(
              `${API_PROJECT_COMPLETE_NOTIFICATION}/${projectId}`,
              {},
              { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            if (notifyRes.status === 200) {
              const completePayload = { ...payload, status: 1 };
              await axios.patch(
                `${API_EDIT_PROJECT_DETAILS}/${projectId}`,
                completePayload,
                { headers: { Authorization: `Bearer ${accessToken}` } }
              );

              toast.success(
                "Project completed and notification sent successfully."
              );
            } else {
              throw new Error(notifyRes.data.message || "Notification failed");
            }
          } catch (notifyErr) {
            await axios.patch(
              `${API_EDIT_PROJECT_DETAILS}/${projectId}`,
              { ...payload, status: 2 },
              { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            toast.error(notifyErr?.message || "Error ");
            return;
          }
        } else {
          toast.success("Project updated successfully.");
        }

        setOriginalProjectData(null);
        setPendingLeadershipDates(null);
        setEditingProjectId(null);
        const newEditableStatus = { ...editableStatus };
        delete newEditableStatus[projectId];
        setEditableStatus(newEditableStatus);

        await fetchProjects(projectId);
        if (searchTerm) {
          setSearchTerm("");
        }
        setShowProjectCompletedModal(false);
        setPendingCompletedProjectId(null);
      } else {
        toast.error(res?.data?.message || "Failed to update project");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Action failed");
    } finally {
      setIsLoadingCompletedProject(false);
      setIsLoadingUpdate(false);
      setHoldToActiveLoading(false);
    }
  };

  const handleCompleteConfirm = async () => {
    await handleUpdateProject(pendingCompletedProjectId, null, true);
  };

  const handleCompleteCancel = () => {
    if (originalProjectData && pendingCompletedProjectId) {
      const updateProject = (projects) =>
        projects.map((proj) =>
          proj.id === pendingCompletedProjectId
            ? { ...proj, projectStatus: originalProjectData.projectStatus }
            : proj
        );

      setProjectList((prev) => updateProject(prev));
      setFilteredItems((prev) => updateProject(prev));
    }

    setShowProjectCompletedModal(false);
    setPendingCompletedProjectId(null);
  };

  const handleHoldToActiveConfirm = async (date) => {
    await handleUpdateProject(
      pendingHoldToActiveProjectId,
      null,
      false,
      true,
      date
    );
    setShowHoldToActiveModal(false);
    setPendingHoldToActiveProjectId(null);
    setHoldToActiveDate(null);
  };

  const handleHoldToActiveCancel = () => {
    if (originalProjectData && pendingHoldToActiveProjectId) {
      const updateProject = (projects) =>
        projects.map((proj) =>
          proj.id === setPendingHoldToActiveProjectId
            ? { ...proj, projectStatus: originalProjectData.projectStatus }
            : proj
        );

      setProjectList((prev) => updateProject(prev));
      setFilteredItems((prev) => updateProject(prev));
    }

    setShowHoldToActiveModal(false);
    setPendingHoldToActiveProjectId(null);
    setHoldToActiveDate(null);
  };

  const handleDelete = async () => {
    if (!deleteTarget.employeeId || !deleteTarget.projectId) return;

    try {
      setIsLoadingDelete(true);

      const res = await axios.delete(
        `${API_DELETE_PROJECT_MEMBERS}/${deleteTarget.employeeId}/${deleteTarget.projectId}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      toast.success(res?.data?.message || "Member deleted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });

      const updateProjects = (projects) =>
        projects.map((proj) =>
          proj.id === deleteTarget.projectId
            ? {
                ...proj,
                members: proj.members.filter(
                  (member) => member.employeeId !== deleteTarget.employeeId
                ),
              }
            : proj
        );

      setProjectList((prev) => updateProjects(prev));
      setFilteredItems((prev) => updateProjects(prev));

      // Modal close
      const modal = document.getElementById("staticBackdropDependentDelete");
      if (modal) {
        const bsModal = window.bootstrap.Modal.getInstance(modal);
        bsModal?.hide();
      }

      setDeleteTarget({ employeeId: null, projectId: null });
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete member", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoadingDelete(false);
    }
  };

  const openMemberModal = (projectId, memberId = null) => {
    document.body.classList.add("modal-open");
    setCurrentProjectId(projectId);
    setEditingMemberId(memberId);

    if (memberId) {
      const project = projectList.find((p) => p.id === projectId);
      const member = project?.members.find((m) => m.id === memberId);
      if (member) {
        setMemberForm({
          id: member.id,
          name: member.name,
          designation: normalizeDesignationValue(member.designation),
          performanceRoleCode: member.performanceRoleCode || "",
          locationType: findDesignationOption(member.designation)?.locationType || "",
          expertise: member.expertise || "",
          joinDate: member.createdDate ? member.createdDate : "",
        });
      }
    } else {
      setMemberForm({
        name: "",
        designation: "",
        performanceRoleCode: "",
        locationType: "",
        expertise: "",
        joinDate: "",
      });
    }
    setShowMemberModal(true);
  };

  const closeMemberModal = () => {
    document.body.classList.remove("modal-open");

    setShowMemberModal(false);
    setCurrentProjectId(null);
    setEditingMemberId(null);
    setMemberForm({
      name: "",
      designation: "",
      performanceRoleCode: "",
      locationType: "",
      expertise: "",
      joinDate: "",
    });
    setSelectedEmployee(null);
    setHrPocs([]);
    setSelectedHrPocIds([]);
    setHrNotified(false);
    setNotifyHrLoading(false);
    setOriginalMemberData(null);
  };

  const fetchProjects = async (projectIdToHydrate = null) => {
    try {
      setIsLoading(true);
      const response = await getApi(API_PROJECT_LIST, accessToken);
      const projectData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      let projects = projectData.map((project) => mapProject(project));

      if (projectIdToHydrate != null) {
        try {
          const teamResponse = await getApi(
            `${API_PROJECT_TEAM}/${projectIdToHydrate}`,
            accessToken,
          );
          const details = teamResponse.data?.data ?? teamResponse.data;

          if (details && !Array.isArray(details)) {
            projects = projects.map((project) =>
              project.id === projectIdToHydrate
                ? mapProject(details, project)
                : project,
            );
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Unable to reload project details",
            { position: toast.POSITION.TOP_RIGHT },
          );
        }
      }

      setProjectList(projects);
      setFilteredItems(projects);
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await getApi(EMPLOYEE_LIST, accessToken);
      const users = res.data?.data || [];

      const options = users.map((u) => ({
        value: u.id,
        label: u.empName,
        employeeCode: u.employeeId,
        currentDesignation: u.designation,
        techStack: u.techStack,
      }));
      setEmployeeList(options);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  const fetchCoreExpertise = async () => {
    setIsExpertiseLoading(true);
    try {
      const response = await getApi(API_PROJECT_EXPERTIES, accessToken);
      const values = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data?.data)
          ? response.data.data
          : [];
      setExpertiseOptions(
        values.map((value) => ({
          value: String(value),
          label: String(value),
        })),
      );
    } catch (error) {
      console.error("Error fetching project expertise:", error);
      setExpertiseOptions([]);
      toast.error("Failed to load project expertise list", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsExpertiseLoading(false);
    }
  };
  useEffect(() => {
    const fetchDeliveryLeads = async () => {
      try {
        const response = await getApi(API_LEAVE_GET_OOD_DL_LIST, accessToken);
        const leads = (
          Array.isArray(response.data)
            ? response.data
            : response.data?.data || []
        ).map((emp) => ({
          value: Number(emp.id),
          label: emp.fullName || "",
        }));
        setDeliveryLead(leads);
      } catch (error) {
        console.error("Error fetching delivery leads:", error);
        setDeliveryLead([]);
      }
    };

    if (!isSqeLabs) fetchDeliveryLeads();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchProjectManagers = async () => {
      try {
        const response = await getApi(
          API_GET_PROJECT_MANAGER_LIST,
          accessToken
        );
        const managers = (response.data?.data || []).map((pm) => ({
          value: Number(pm.id),
          label: `${pm.firstName} ${pm.lastName}` || "Unnamed Manager",
        }));
        setProjectManagers(managers);
      } catch (error) {
        console.error("Error fetching project managers:", error);
        setProjectManagers([]);
      }
    };
    if (!isSqeLabs) fetchProjectManagers();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchProgramManagers = async () => {
      try {
        const response = await getApi(
          API_GET_PROGRAM_MANAGER_LIST,
          accessToken
        );
        const managers = (response.data?.data || []).map((pm) => ({
          value: pm.id,
          label: `${pm.firstName} ${pm.lastName}` || "Unnamed Manager",
        }));
        setProgramManagers(managers);
      } catch (error) {
        console.error("Error fetching program managers:", error);
        setProgramManagers([]);
      }
    };
    if (!isSqeLabs) fetchProgramManagers();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchPrincipalSponsors = async () => {
      try {
        const response = await getApi(
          API_GET_PRINCIPAL_SPONSOR_LIST,
          accessToken
        );
        const sponsors = (response.data?.data || []).map((sponsor) => ({
          value: sponsor.id,
          label:
            `${sponsor.firstName} ${sponsor.lastName}` || "Unnamed Sponsor",
        }));
        setPrincipalSponsors(sponsors);
      } catch (error) {
        console.error("Error fetching principal sponsors:", error);
        setPrincipalSponsors([]);
      }
    };
    if (!isSqeLabs) fetchPrincipalSponsors();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchLBA = async () => {
      try {
        const response = await getApi(
          API_GET_LEAD_BUSINESS_ANALYST_LIST,
          accessToken
        );
        const lbas = (response.data?.data || []).map((lba) => ({
          value: lba.id,
          label: `${lba.firstName} ${lba.lastName}`,
        }));
        setLeadBusinessAnalysts(lbas);
      } catch (error) {
        console.error("Error fetching LBAs:", error);
        setLeadBusinessAnalysts([]);
      }
    };
    if (!isSqeLabs) fetchLBA();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchHeadOfDelivery = async () => {
      try {
        const response = await getApi(
          API_GET_HEAD_OF_DELIVERY_LIST,
          accessToken,
        );
        const hods = (response.data?.data || []).map((hod) => ({
          value: hod.id,
          label: `${hod.firstName} ${hod.lastName}`,
        }));
        setHeadOfDeliveryList(hods);
      } catch (error) {
        console.error("Error fetching Heads of Delivery:", error);
        setHeadOfDeliveryList([]);
      }
    };
    if (!isSqeLabs) fetchHeadOfDelivery();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    if (!isSqeLabs) return;
    let active = true;
    getApi(API_SQE_PROJECT_LEAD_MEMBERS, accessToken)
      .then((response) => {
        if (active) setSqeLeadMembers(getSqeProjectLeadOptions(response));
      })
      .catch((error) => {
        console.error("Error fetching SQE project lead members:", error);
        if (active) {
          setSqeLeadMembers([]);
          toast.error("Unable to load SQE project lead members.");
        }
      });
    return () => { active = false; };
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    fetchProjects();
    fetchEmployees();
    fetchCoreExpertise();
  }, []);

  const isValidDate = (d) => d instanceof Date && !isNaN(d.getTime());

  const addMember = async (e) => {
    e.preventDefault();
    try {
      if (selectedEmployeeRequiresTechStack) {
        toast.error(
          "Assign a Tech Stack to this employee before adding them to a project.",
          { position: toast.POSITION.TOP_RIGHT },
        );
        return;
      }
      const selectedDesignation = findDesignationOption(memberForm.designation, designationOptions);
      if (!selectedEmployee?.value || !memberForm.locationType ||
          !selectedDesignation || selectedDesignation.locationType !== memberForm.locationType) {
        toast.error("Select an employee, designation type, and designation.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      if (selectedDesignation.performanceRoles?.length && !memberForm.performanceRoleCode) {
        toast.error("Select a Performance Lens role.");
        return;
      }
      setIsLoading(true);

      const project = projectList.find((p) => p.id === currentProjectId);

      if (project?.timesheetAccessMode === "GLOBAL") {
        toast.error("Members cannot be assigned to a global project.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        closeMemberModal();
        return;
      }

      if (
        ["PROJECT_MANAGER", "PROJECT_MANAGER_ONSHORE"].includes(memberForm.designation) &&
        project?.projectManagerId === selectedEmployee.value
      ) {
        toast.error("This Project Manager is already assigned!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      const joinDate = memberForm.joinDate
        ? new Date(memberForm.joinDate)
        : null;
      const endDate = memberForm.endDate ? new Date(memberForm.endDate) : null;

      if (joinDate && endDate) {
        if (endDate < joinDate) {
          toast.error("End date must be after joining date!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
      }

      const payload = {
        projectId: currentProjectId,
        employeeId: selectedEmployee.value,
        designation: selectedDesignation.legacyValue ?? null,
        globalDesignationId: selectedDesignation.id,
        performanceRoleCode: memberForm.performanceRoleCode || null,
        expertise: String(memberForm.expertise),
        createdBy: userData.id,
        createdAt: isValidDate(joinDate) ? toUTCDateString(joinDate) : null,
        endDate: isValidDate(endDate) ? toUTCDateString(endDate) : null,
        status: memberForm.status,
      };

      const res = await axios({
        method: "post",
        url: API_ASSIGN_PROJECT_MEMBERS,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
      });

      const newMember = {
        id: res.data?.data?.id,
        name: selectedEmployee.label,
        designation: memberForm.designation,
        performanceRoleCode: memberForm.performanceRoleCode || null,
        expertise: String(memberForm.expertise),
        joinDate: memberForm.joinDate,
        endDate: memberForm.endDate,
        employeeId: selectedEmployee.value,
        status: memberForm.status,
      };

      // Update both projectList and filteredItems
      const updateProjects = (projects) =>
        projects.map((proj) =>
          proj.id === currentProjectId
            ? { ...proj, members: [...proj.members, newMember] }
            : proj
        );

      setProjectList((prev) => updateProjects(prev));
      setFilteredItems((prev) => updateProjects(prev));

      toast.success(res?.data?.message || "Member assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });

      closeMemberModal();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const notifyHrForTechStack = async () => {
    if (
      !selectedEmployee?.value ||
      !currentProjectId ||
      notifyHrLoading ||
      selectedHrPocIds.length === 0
    )
      return;

    setNotifyHrLoading(true);
    try {
      const response = await axios.post(
        `${API_PROJECT_ASSIGNMENT_NOTIFY_HR}?employeeId=${encodeURIComponent(
          selectedEmployee.value,
        )}&projectId=${encodeURIComponent(
          currentProjectId,
        )}&hrPocIds=${encodeURIComponent(selectedHrPocIds.join(","))}`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } },
      );
      setHrNotified(true);
      toast.success(response.data?.message || "HR team notified successfully.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to notify the HR team.",
        { position: toast.POSITION.TOP_RIGHT },
      );
    } finally {
      setNotifyHrLoading(false);
    }
  };

  const toggleHrPoc = (pocId) => {
    setHrNotified(false);
    setSelectedHrPocIds((current) =>
      current.includes(pocId)
        ? current.filter((id) => id !== pocId)
        : [...current, pocId],
    );
  };

  const toUTCDateString = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00:00`;
  };

  const updateMember = async (memberData = null, isDeallocating = false) => {
    try {
      setIsLoading(true);

      const formData = memberData || memberForm;

      if (!formData.designation) {
        toast.error("Designation is required!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      const joinDate = formData.joinDate ? new Date(formData.joinDate) : null;
      const endDate = formData.endDate ? new Date(formData.endDate) : null;
      if (!isDeallocating && joinDate && endDate) {
        if (endDate < joinDate) {
          toast.error("End date must be after joining date!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
      }

      const payload = {
        name: formData.name,
        designation: findDesignationOption(formData.designation)?.legacyValue ?? null,
        globalDesignationId: findDesignationOption(formData.designation)?.id ?? null,
        performanceRoleCode: formData.performanceRoleCode || null,
        expertise: String(formData.expertise || ""),
        createdAt: formData.joinDate
          ? toUTCDateString(formData.joinDate)
          : null,
        endDate: formData.endDate ? toUTCDateString(formData.endDate) : null,
        status: formData.status,
        projectId: formData.projectId || currentProjectId,
        reason: "",
      };

      if (formData.status === StatusEnum.DEALLOCATED && formData.reason) {
        payload.reason = formData.reason;
      }

      const res = await axios({
        method: "put",
        url: `${API_EDIT_PROJECT_MEMBERS}/${editingMemberId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: payload,
      });

      await fetchProjects(formData.projectId || currentProjectId);
      setSearchTerm("");
      const message =
        formData.status === StatusEnum.DEALLOCATED
          ? "Member Deallocated Successfully."
          : "Member Updated Successfully.";

      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
      });

      if (!memberData) {
        closeMemberModal();
      }

      return res;
    } catch (err) {
      console.error("Update member error:", err);

      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to update member. Please try again.";

      toast.error(errorMessage, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const saveMember = async (e) => {
    e.preventDefault();

    if (editingMemberId) {
      await updateMember();
    } else {
      await addMember(e);
    }
  };

  const handleDeallocateConfirm = async () => {
    setIsLoading(true);
    try {
      const updatedMemberForm = {
        ...memberForm,
        status: StatusEnum.DEALLOCATED,
        reason: selectedReason?.value,
      };

      const endDate = new Date(memberForm.endDate);
      const today = new Date();

      if (endDate > today) {
        toast.error("End date must be on or before the current date.");
        setIsLoading(false);
        return;
      }

      await updateMember(updatedMemberForm, true);

      setShowConfirmDeallocateModal(false);
      setShowDeallocateModal(false);
      closeMemberModal();
    } catch (error) {
      console.error("Deallocation failed", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper-body overall-projects-page">
      {/* Page Heading */}
      <div className="page-heading">
        {/* <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div> */}
        <PageTitle title={title} description={description} />
        {/* <div className="total">
          Total Projects :{" "}
          <span>{searchTerm ? filteredItems.length : projectList.length}</span>
        </div> */}
      </div>

      <ProjectStatusSummary
        projects={projectList}
        selected={projectStatusFilter}
        onSelect={handleProjectStatusFilter}
      />

      {/* Filters */}
      <div className="filters">
        <div className="search">
          <input
            type="text"
            name="search"
            placeholder="Search By Project Name"
            value={searchTerm}
            onChange={handleSearch}
            required
          />
          <img src="/assets/images/search-ico.svg" width="14" alt="Search" />
        </div>
        <Link className="btn theme-button" to="/dashboard/createProject">
          Create Project
        </Link>
        <div className="actions"></div>
      </div>

      {isLoading && (
        <div className="centered-loader">
          <ThreeDots
            height="100"
            width="100"
            radius="9"
            color="blue"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}

      {!isLoading && (
        <div className="accordion" id="accordionProjects">
          {displayedProjects.length === 0 ? (
            <p className="fs-4 m-5 text-secondary text-center">
              No Records Available
            </p>
          ) : (
            displayedProjects.map((project) => (
              <div
                className="accordion-item project-accordion-item"
                key={`${project.id}-${project.projectStatus}`}
              >
                <h2
                  className="accordion-header"
                  id={`heading-${project.id}`}
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    whiteSpace: "normal",
                  }}
                >
                  <button
                    className={`accordion-button ${
                      openProjectId === project.id ? "" : "collapsed"
                    }`}
                    type="button"
                    onClick={() => toggleProject(project.id)}
                  >
                    <span>{project.projectName}</span>

                    <span
                      className={`project-status-badge ${
                        project.projectStatus === 1
                          ? "badge-complete"
                          : project.projectStatus === 3
                            ? "badge-closed"
                          : project.projectStatus === 2
                            ? "badge-onhold"
                            : "badge-active"
                      }`}
                    >
                      {project.projectStatus === 1
                        ? "Completed"
                        : project.projectStatus === 3
                          ? "Closed"
                        : project.projectStatus === 2
                          ? "On Hold"
                          : "Active"}
                    </span>

                    {openProjectId === project.id ? (
                      <MdOutlineKeyboardArrowUp className="dropdown-icon" />
                    ) : (
                      <MdKeyboardArrowDown className="dropdown-icon" />
                    )}
                  </button>
                </h2>
                <div
                  id={`collapse-${project.id}`}
                  className={`accordion-collapse collapse ${
                    openProjectId === project.id ? "show" : ""
                  }`}
                  aria-labelledby={`heading-${project.id}`}
                  data-bs-parent="#accordionProjects"
                >
                  <div className="accordion-body p-4">
                    {loadingProjectId === project.id ? (
                      <div className="d-flex justify-content-center align-items-center py-4">
                        <ThreeDots
                          height="24"
                          width="48"
                          radius="9"
                          color="#0d6efd"
                          ariaLabel="project-details-loading"
                          visible={true}
                        />
                      </div>
                    ) : (
                      <>
                    <div className="row">
                      <div className="col-md-10"></div>
                      <div className="col-md-2">
                        {editingProjectId !== project.id &&
                          ![1, 3].includes(project.projectStatus) && (
                            <a
                              style={{
                                float: "right",
                                fontSize: "18px",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              onClick={() => beginEditProject(project)}
                            >
                              <i class="fa fa-edit"></i>
                            </a>
                          )}
                      </div>
                    </div>
                    {editingProjectId !== project.id && (
                      <>
                        <ProjectListDetails project={project} />

                        {["GLOBAL", "DEPARTMENT"].includes(project.timesheetAccessMode) ? (
                          <DepartmentProjectAccess
                            project={project}
                            employees={employeeList}
                          />
                        ) : (
                        <div className="col-md-12 mt-4">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5
                              className="mb-0"
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                borderBottom: "none",
                                borderRadius: "2px",
                                padding: "2px 10px",
                                backgroundColor: "white",
                              }}
                            >
                              Team Members
                            </h5>
                            <div className="d-flex gap-2 flex-wrap justify-content-end">
                              {![1, 3].includes(project.projectStatus) && (
                                <TeamMembersNotificationModal
                                  projectId={project.id}
                                  iscreatedPush={project.iscreatedPush}
                                  onStatusUpdate={handleProjectStatusUpdate}
                                  disabled={project.projectStatus === 2}
                                  project={project}
                                />
                              )}

                              <ProjectMemberHistoryDrawer
                                projectId={project.id}
                                projectName={project.projectName}
                                employees={employeeList}
                              />

                              {project.timesheetAccessMode === "ASSIGNED_ONLY" &&
                                ![1, 3].includes(project.projectStatus) && (
                                <button
                                  className="btn theme-button"
                                  type="button"
                                  onClick={() => openMemberModal(project.id)}
                                  disabled={project.projectStatus === 2}
                                >
                                  Add Member
                                </button>
                              )}
                            </div>
                          </div>
                          {project.members && project.members.length > 0 ? (
                            <SortableTable
                              columns={columns(project.id)}
                              data={project.members}
                            />
                          ) : (
                            <NoRecordsAvailable />
                          )}
                        </div>
                        )}
                      </>
                    )}
                    {editingProjectId === project.id && (
                      <form
                        onSubmit={(e) => handleUpdateProject(project.id, e)}
                      >
                        <div className="row mb-2 ">
                          <div className="col-md-6 px-4 mt-2 project-details">
                            {/* Project Name */}
                            <div className="row p-2 mt-2 align-items-center ">
                              <label className="col-md-5 text-black-50">
                                Project Name
                              </label>
                              <div className="col-md-7 p-3 project-details-field">
                                {project.projectName}
                              </div>
                            </div>
                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Project Type
                              </label>
                              <div className="col-md-7 p-0  ">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  options={projectTypeOptions}
                                  value={
                                    project.projectType
                                      ? projectTypeOptions.find(
                                          (type) =>
                                            type.value === project.projectType,
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    const value = selected
                                      ? selected.value
                                      : null;
                                    const label = selected
                                      ? selected.label
                                      : null;

                                    handleProjectChange(
                                      project.id,
                                      "projectType",
                                      value,
                                      label,
                                    );
                                  }}
                                  placeholder="Select Project Type"
                                />
                              </div>
                            </div>
                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Delivery Lead
                              </label>
                              <div className="col-md-7 p-0  ">
                                <SqeEditLeadField isSqeLabs={isSqeLabs} options={deliveryLeadOptions}>
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  options={deliveryLeadOptions}
                                  value={
                                    project.dlId
                                      ? deliveryLeadOptions.find(
                                          (lead) => Number(lead.value) === Number(project.dlId),
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    const value = selected
                                      ? selected.value
                                      : null;
                                    const label = selected
                                      ? selected.label
                                      : null;

                                    handleProjectChange(
                                      project.id,
                                      "dlId",
                                      value,
                                      label,
                                    );
                                  }}
                                  placeholder="Select the Delivery Lead"
                                />
                                </SqeEditLeadField>
                              </div>
                            </div>

                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Project Manager
                              </label>
                              <div className="col-md-7 p-0  ">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Project Manager"
                                  options={selectableProjectManagers}
                                  value={
                                    project.projectManagerId
                                      ? selectableProjectManagers.find(
                                          (emp) =>
                                            Number(emp.value) ===
                                            Number(project.projectManagerId),
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    handleProjectChange(
                                      project.id,
                                      "projectManagerId",
                                      selected ? selected.value : null,
                                      selected ? selected.label : null,
                                    );
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Program Manager
                              </label>
                              <div className="col-md-7 p-0  ">
                                <SqeEditLeadField isSqeLabs={isSqeLabs} options={programManagerOptions}>
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Program Manager"
                                  options={programManagerOptions}
                                  value={
                                    project.programManagerId != null
                                      ? programManagerOptions.find(
                                          (emp) =>
                                            Number(emp.value) ===
                                            Number(project.programManagerId),
                                        ) ?? null
                                      : null
                                  }
                                  onChange={(selected) => {
                                    handleProjectChange(
                                      project.id,
                                      "programManagerId",
                                      selected
                                        ? toOptionalId(selected.value)
                                        : null,
                                      selected ? selected.label : null,
                                    );
                                  }}
                                  isClearable={true}
                                />
                                </SqeEditLeadField>
                              </div>
                            </div>
                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Principal Sponsor
                              </label>
                              <div className="col-md-7 p-0  ">
                                <SqeEditLeadField isSqeLabs={isSqeLabs} options={principalSponsorOptions}>
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Principal Sponsor"
                                  options={principalSponsorOptions}
                                  value={
                                    project.principalSponsorId
                                      ? principalSponsorOptions.find(
                                          (emp) =>
                                            Number(emp.value) ===
                                            Number(project.principalSponsorId),
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    const value = selected
                                      ? selected.value
                                      : null;
                                    const label = selected
                                      ? selected.label
                                      : null;

                                    handleProjectChange(
                                      project.id,
                                      "principalSponsorId",
                                      value,
                                      label,
                                    );
                                  }}
                                />
                                </SqeEditLeadField>
                              </div>
                            </div>

                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className="col-md-5 text-black-50">
                                Lead Business Analyst
                              </label>
                              <div className="col-md-7 p-0">
                                <SqeEditLeadField isSqeLabs={isSqeLabs} options={leadBusinessAnalystOptions}>
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Lead Business Analyst"
                                  options={leadBusinessAnalystOptions}
                                  value={
                                    project.leadBusinessAnalyst
                                      ? leadBusinessAnalystOptions.find(
                                          (emp) =>
                                            Number(emp.value) ===
                                            Number(project.leadBusinessAnalyst),
                                        )
                                      : null
                                  }
                                  onChange={(selected) => {
                                    handleProjectChange(
                                      project.id,
                                      "leadBusinessAnalyst",
                                      selected ? selected.value : null,
                                      selected ? selected.label : null,
                                    );
                                  }}
                                  isClearable={true}
                                />
                                </SqeEditLeadField>
                              </div>
                            </div>

                            <div
                              className="row p-2 mt-2 align-items-center"
                              style={{ zIndex: 200 }}
                            >
                              <label className={`col-md-5 text-black-50${isSqeLabs && sqeLeadMembers.length === 1 ? "" : " has-asterisk"}`}>
                                Head of Delivery
                              </label>
                              <div className="col-md-7 p-0">
                                <SqeEditLeadField isSqeLabs={isSqeLabs} options={headOfDeliveryOptions}>
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Head of Delivery"
                                  options={headOfDeliveryOptions}
                                  value={
                                    project.hodId
                                      ? headOfDeliveryOptions.find(
                                          (hod) =>
                                            Number(hod.value) ===
                                            Number(project.hodId),
                                        ) || null
                                      : null
                                  }
                                  onChange={(selected) =>
                                    handleProjectChange(
                                      project.id,
                                      "hodId",
                                      selected ? selected.value : null,
                                      selected ? selected.label : null,
                                    )
                                  }
                                  isClearable
                                  required
                                />
                                </SqeEditLeadField>
                              </div>
                            </div>

                            {editableStatus[project.id] === 2 && (
                              <div
                                className="row p-2 mt-2 align-items-center"
                                style={{ zIndex: 200 }}
                              >
                                <label className="col-md-5 text-black-50">
                                  Project Status
                                </label>
                                <div className="col-md-7 p-0">
                                  <Select
                                    className="custom-select custom-edit-select"
                                    classNamePrefix="react-select"
                                    options={projectStatusOptions}
                                    value={
                                      project.projectStatus !== null &&
                                      project.projectStatus !== undefined
                                        ? projectStatusOptions.find(
                                            (type) =>
                                              type.value ===
                                              project.projectStatus,
                                          )
                                        : null
                                    }
                                    onChange={(selected) => {
                                      const value = selected
                                        ? selected.value
                                        : null;
                                      const label = selected
                                        ? selected.label
                                        : null;

                                      handleProjectChange(
                                        project.id,
                                        "projectStatus",
                                        value,
                                        label,
                                      );
                                    }}
                                    placeholder="Select Project Status"
                                  />
                                </div>
                              </div>
                            )}

                            <div className="row p-2 mt-2 align-items-center justify-content-between">
                              <label className="col-md-5 text-black-50 mb-2">
                                SOW
                              </label>
                              <div className="col-md-7 d-flex justify-content-between p-0 gap-3">
                                <div className="flex-fill position-relative">
                                  <span className="editDateBadgeStyle">
                                    Start Date
                                  </span>
                                  <DatePicker
                                    selected={
                                      project.sowStartDate
                                        ? new Date(project.sowStartDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleProjectChange(
                                        project.id,
                                        "sowStartDate",
                                        date ? format(date, "MM-dd-yyyy") : "",
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="custom-date custom-edit-project-date py-3 px-2 text-center w-100"
                                    showIcon
                                    toggleCalendarOnIconClick
                                    required
                                  />
                                </div>

                                <div className="flex-fill position-relative">
                                  <span className="editDateBadgeStyle">
                                    End Date
                                  </span>
                                  <DatePicker
                                    selected={
                                      project.sowEndDate
                                        ? new Date(project.sowEndDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleProjectChange(
                                        project.id,
                                        "sowEndDate",
                                        date ? format(date, "MM-dd-yyyy") : "",
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    minDate={project.sowStartDate}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="py-3 px-2 text-center custom-date custom-edit-project-date w-100"
                                    showIcon
                                    toggleCalendarOnIconClick
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row justify-content-between p-2 mt-2 align-items-center">
                              <label className="col-md-5 text-black-50 mb-2">
                                Actual
                              </label>
                              <div className="col-md-7 d-flex justify-content-between p-0 gap-3">
                                <div className="flex-fill position-relative">
                                  <span className="editDateBadgeStyle">
                                    Start Date
                                  </span>
                                  <DatePicker
                                    selected={
                                      project.startDate
                                        ? new Date(project.startDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleProjectChange(
                                        project.id,
                                        "startDate",
                                        date ? format(date, "MM-dd-yyyy") : "",
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="custom-date custom-edit-project-date py-3 px-2 text-center w-100"
                                    showIcon
                                    toggleCalendarOnIconClick
                                  />
                                </div>

                                <div className="flex-fill position-relative">
                                  <span className="editDateBadgeStyle">
                                    End Date
                                  </span>
                                  <DatePicker
                                    selected={
                                      project.endDate
                                        ? new Date(project.endDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleProjectChange(
                                        project.id,
                                        "endDate",
                                        date ? format(date, "MM-dd-yyyy") : "",
                                      )
                                    }
                                    minDate={
                                      project.startDate
                                        ? new Date(project.startDate)
                                        : null
                                    }
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="mm/dd/yyyy"
                                    className="custom-date custom-edit-project-date py-3 px-2 text-center w-100"
                                    showIcon
                                    toggleCalendarOnIconClick
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 px-4 mt-3 project-details">
                            <div className="row p-2 mt-2 align-items-center">
                              <label className="col-md-5 text-black-50">
                                Need Approval
                              </label>
                              <div className="col-md-7 p-0">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  inputId={`needsApproval-${project.id}`}
                                  placeholder="Select Need Approval"
                                  options={needsApprovalOptions}
                                  value={
                                    needsApprovalOptions.find(
                                      (option) =>
                                        option.value === project.needsApproval,
                                    ) || needsApprovalOptions[1]
                                  }
                                  onChange={(selected) =>
                                    handleProjectChange(
                                      project.id,
                                      "needsApproval",
                                      selected?.value ?? false,
                                    )
                                  }
                                  isClearable={false}
                                />
                              </div>
                            </div>

                            <div className="row p-2 mt-2 align-items-center">
                              <label className="col-md-5 text-black-50">
                                Trackable
                              </label>
                              <div className="col-md-7 p-0">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  inputId={`trackable-${project.id}`}
                                  placeholder="Select Trackable"
                                  options={trackableOptions}
                                  value={
                                    trackableOptions.find(
                                      (option) =>
                                        option.value === project.trackable,
                                    ) || trackableOptions[1]
                                  }
                                  onChange={(selected) =>
                                    handleProjectChange(
                                      project.id,
                                      "trackable",
                                      selected?.value ?? false,
                                    )
                                  }
                                  isClearable={false}
                                />
                              </div>
                            </div>

                            <div className="row p-2 mt-2 align-items-start">
                              <label className="col-md-5 text-black-50">
                                Timesheet Access
                              </label>
                              <div className="col-md-7 p-0">
                                <Select
                                  className="custom-select custom-edit-select"
                                  classNamePrefix="react-select"
                                  inputId={`timesheetAccessMode-${project.id}`}
                                  options={timesheetAccessOptions}
                                  value={timesheetAccessOptions.find(
                                    (option) => option.value === project.timesheetAccessMode,
                                  ) || timesheetAccessOptions[0]}
                                  onChange={(selected) =>
                                    handleProjectChange(
                                      project.id,
                                      "timesheetAccessMode",
                                      selected?.value ?? "ASSIGNED_ONLY",
                                    )
                                  }
                                  isClearable={false}
                                />
                                {project.timesheetAccessMode === "GLOBAL" && (
                                  <small className="text-warning d-block mt-1">
                                    Available to every eligible employee without member allocation.
                                  </small>
                                )}
                              </div>
                            </div>

                            <div>
                              <label className=" mb-2 py-2 mt-3 text-black-50">
                                Project Description
                              </label>
                              <div className="input-group">
                                <CharLimitTextArea
                                  id="commercialSummary"
                                  name="commercialSummary"
                                  required
                                  rows={16}
                                  placeholder="Type Here"
                                  maxLength={1500}
                                  value={project.commercialSummary}
                                  onChange={(e) =>
                                    handleProjectChange(
                                      project.id,
                                      "commercialSummary",
                                      e.target.value,
                                    )
                                  }
                                  lengthParam={
                                    project.commercialSummary?.length || 0
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Buttons */}
                        <div className="row mt-3">
                          <div className="col-md-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary btn-md"
                              disabled={
                                isLoadingUpdate ||
                                !hasProjectChanges(project, originalProjectData)
                              }
                            >
                              {isLoadingUpdate ? (
                                <ThreeDots
                                  height="25"
                                  width="80"
                                  radius="9"
                                  color="white"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{}}
                                  wrapperClassName=""
                                  visible={true}
                                />
                              ) : (
                                "Update"
                              )}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary btn-md ms-2"
                              onClick={() => {
                                if (originalProjectData) {
                                  const updateProject = (projects) =>
                                    projects.map((proj) =>
                                      proj.id === originalProjectData.id
                                        ? originalProjectData
                                        : proj,
                                    );

                                  setProjectList((prev) => updateProject(prev));
                                  setFilteredItems((prev) =>
                                    updateProject(prev),
                                  );
                                }

                                setEditingProjectId(null);
                                setOriginalProjectData(null);
                                setPendingLeadershipDates(null);
                                setLeadershipDateRequest(null);
                              }}
                            >
                              &nbsp; Close &nbsp;
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {showMemberModal &&
        (() => {
          const project = projectList.find((p) => p.id === currentProjectId);
          if (editingMemberId) {
            return (
              <div
                className="modal show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content rounded-lg">
                    {/* Header */}
                    <div className="modal-header ">
                      <h5 className="modal-title">Edit Team Member</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={closeMemberModal}
                        style={{ filter: "invert(0.3)" }}
                      ></button>
                    </div>

                    <form onSubmit={saveMember}>
                      <div
                        className="modal-body py-5 px-4 project-member-form"
                        style={{ backgroundColor: "#fafbff" }}
                      >
                        <div className="container-fluid">
                          <div className="row justify-content-center">
                            <div className="col-md-10">
                              {/* Full Name Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    Employee Name
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    options={employeeList}
                                    value={selectedEmployee}
                                    isDisabled
                                    placeholder="Select Employee"
                                  />
                                </div>
                              </div>

                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3"><label className="form-label mb-0 text-end">Designation Type</label></div>
                                <div className="col-md-8">
                                  <Select
                                    placeholder="Select Onshore or Offshore"
                                    options={projectDesignationTypeOptions}
                                    value={projectDesignationTypeOptions.find((option) => option.value === memberForm.locationType) || null}
                                    onChange={(option) => setMemberForm((current) => ({ ...current, locationType: option?.value || "", designation: "", performanceRoleCode: "" }))}
                                    isClearable
                                  />
                                </div>
                              </div>

                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    Designation
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    placeholder={isDesignationLoading ? "Loading Designations" : "Select Designation"}
                                    options={designationOptionsForType(designationOptions, memberForm.locationType)}
                                    isDisabled={isDesignationLoading || !memberForm.locationType}
                                    value={
                                      memberForm.designation
                                        ? findDesignationOption(
                                            memberForm.designation,
                                            designationOptionsForType(designationOptions, memberForm.locationType),
                                          )
                                        : null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        designation: option?.value || "",
                                        performanceRoleCode: "",
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3"><label className="form-label mb-0 text-end" htmlFor="edit-member-performance-role-trigger">Performance Role</label></div>
                                <div className="col-md-8"><V2Select id="edit-member-performance-role" value={memberForm.performanceRoleCode || ""}
                                  onChange={(value) => setMemberForm((current) => ({ ...current, performanceRoleCode: value }))}
                                  options={performanceLensRoleSelectOptions(findDesignationOption(memberForm.designation, designationOptions))}
                                  placeholder="Select performance role" disabled={!findDesignationOption(memberForm.designation, designationOptions)?.performanceRoles?.length}
                                  required={Boolean(findDesignationOption(memberForm.designation, designationOptions)?.performanceRoles?.length)} /></div>
                              </div>

                              {/* Project Expertise Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end">
                                    Project Expertise
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    placeholder={
                                      isExpertiseLoading
                                        ? "Loading Project Expertise"
                                        : "Select Project Expertise"
                                    }
                                    options={expertiseOptions}
                                    value={
                                      expertiseOptions.find(
                                        (option) => option.value === memberForm.expertise,
                                      ) || null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        expertise: option ? option.value : "",
                                      })
                                    }
                                    isLoading={isExpertiseLoading}
                                    isDisabled={isExpertiseLoading}
                                    isSearchable
                                    isClearable
                                  />
                                </div>
                              </div>

                              {/* Join Date Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    Joining Date
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <DatePicker
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="mm/dd/yyyy"
                                    selected={
                                      memberForm.joinDate
                                        ? new Date(memberForm.joinDate)
                                        : null
                                    }
                                    minDate={
                                      project?.sowStartDate
                                        ? new Date(project.sowStartDate)
                                        : null
                                    }
                                    maxDate={
                                      project?.sowEndDate
                                        ? new Date(project.sowEndDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleDateChange("joinDate", date)
                                    }
                                    required
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="border"
                                    style={{
                                      borderColor: "#e1e5f7",
                                      borderRadius: "8px",
                                      padding: "10px 12px",
                                      fontSize: "15px",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* End Date */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    End Date
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <DatePicker
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="mm/dd/yyyy"
                                    selected={
                                      memberForm.endDate
                                        ? new Date(memberForm.endDate)
                                        : null
                                    }
                                    minDate={
                                      memberForm.joinDate
                                        ? new Date(memberForm.joinDate)
                                        : project?.sowStartDate
                                          ? new Date(project.sowStartDate)
                                          : null
                                    }
                                    maxDate={
                                      project?.endDate
                                        ? new Date(project.endDate)
                                        : project?.sowEndDate
                                          ? new Date(project.sowEndDate)
                                          : null
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(date) =>
                                      handleDateChange("endDate", date)
                                    }
                                    className="border"
                                    style={{
                                      borderColor: "#e1e5f7",
                                      borderRadius: "8px",
                                      padding: "10px 12px",
                                      fontSize: "15px",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Status Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label
                                    className="form-label mb-0 text-end"
                                    style={{ color: "#333" }}
                                  >
                                    Status
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    options={StatusOptions}
                                    value={
                                      StatusOptions.find(
                                        (opt) =>
                                          opt.value === memberForm.status,
                                      ) || null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        status: option.value,
                                      })
                                    }
                                    placeholder="Select Status"
                                    isDisabled={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer */}
                      <div
                        className="modal-footer rounded-lg-bottom"
                        style={{
                          backgroundColor: "#f8f9ff",
                          borderTop: "1px solid #e1e5f7",
                        }}
                      >
                        <button
                          type="button"
                          className="btn px-4 py-2"
                          onClick={closeMemberModal}
                          style={{
                            backgroundColor: "#6c757d",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn theme-button"
                          disabled={
                            (isLoading && !showConfirmDeallocateModal) ||
                            !hasMemberChanges(memberForm, originalMemberData)
                          }
                        >
                          {isLoading && !showConfirmDeallocateModal ? (
                            <ThreeDots
                              height="25"
                              width="80"
                              radius="9"
                              color="white"
                              ariaLabel="three-dots-loading"
                              visible={true}
                            />
                          ) : (
                            "Save Changes"
                          )}
                        </button>
                        <button
                          type="button"
                          className="btn px-4 py-2"
                          onClick={() => {
                            setIsLoading(false);
                            setSelectedReason(null);
                            setShowDeallocateModal(true);
                          }}
                          style={{
                            backgroundColor: "#d63737ff",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                          }}
                          disabled={!memberForm.endDate}
                        >
                          Deallocate
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            );
          } else {
            // --- Add Modal Code ---
            return (
              <div
                className="modal show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content rounded-lg">
                    {/* Header */}
                    <div className="modal-header">
                      <h5 className="modal-title">Add New Member</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={closeMemberModal}
                        style={{ filter: "invert(0.3)" }}
                      ></button>
                    </div>

                    <form onSubmit={saveMember}>
                      <div
                        className="modal-body py-5 px-4 project-member-form"
                        style={{ backgroundColor: "#fafbff" }}
                      >
                        <div className="container-fluid">
                          <div className="row justify-content-center">
                            <div className="col-md-10">
                              {/* Full Name Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end has-asterisk">
                                    Employee Name
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    options={employeeList}
                                    value={selectedEmployee}
                                    onChange={(option) => {
                                      setSelectedEmployee(option);
                                      setHrNotified(false);
                                      setMemberForm({
                                        ...memberForm,
                                        name: option ? option.label : "",
                                        locationType: "",
                                        designation: "",
                                      });
                                    }}
                                    formatOptionLabel={(option, meta) =>
                                      meta.context === "menu" ? (
                                        <div>
                                          <div>{option.label}</div>
                                          <small className="text-muted">
                                            {option.currentDesignation ||
                                              "Designation not assigned"}
                                          </small>
                                        </div>
                                      ) : (
                                        option.label
                                      )
                                    }
                                    placeholder="Search and select employee..."
                                    isSearchable
                                    isClearable
                                    required
                                  />
                                </div>
                              </div>

                              {selectedEmployee && !selectedEmployeeRequiresTechStack && (
                                <>
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3"><label className="form-label mb-0 text-end has-asterisk">Designation Type</label></div>
                                <div className="col-md-8">
                                  <Select
                                    placeholder="Select Onshore or Offshore"
                                    options={projectDesignationTypeOptions}
                                    value={projectDesignationTypeOptions.find((option) => option.value === memberForm.locationType) || null}
                                    onChange={(option) => setMemberForm((current) => ({ ...current, locationType: option?.value || "", designation: "", performanceRoleCode: "" }))}
                                    isClearable
                                    required
                                  />
                                </div>
                              </div>

                              {/* Role Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end has-asterisk">
                                    Designation
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    placeholder={isDesignationLoading ? "Loading Designations" : "Select Designation"}
                                    options={designationOptionsForType(designationOptions, memberForm.locationType)}
                                    isDisabled={isDesignationLoading || !memberForm.locationType}
                                    value={
                                      memberForm.designation
                                        ? findDesignationOption(
                                            memberForm.designation,
                                            designationOptionsForType(designationOptions, memberForm.locationType),
                                          )
                                        : null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        designation: option ? option.value : "",
                                        performanceRoleCode: "",
                                      })
                                    }
                                    required
                                    isClearable
                                  />
                                </div>
                              </div>

                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3"><label className="form-label mb-0 text-end" htmlFor="add-member-performance-role-trigger">Performance Role</label></div>
                                <div className="col-md-8"><V2Select id="add-member-performance-role" value={memberForm.performanceRoleCode || ""}
                                  onChange={(value) => setMemberForm((current) => ({ ...current, performanceRoleCode: value }))}
                                  options={performanceLensRoleSelectOptions(findDesignationOption(memberForm.designation, designationOptions))}
                                  placeholder="Select performance role" disabled={!findDesignationOption(memberForm.designation, designationOptions)?.performanceRoles?.length}
                                  required={Boolean(findDesignationOption(memberForm.designation, designationOptions)?.performanceRoles?.length)} /></div>
                              </div>
                                </>
                              )}

                              {selectedEmployeeRequiresTechStack ? (
                                <div className="alert alert-warning border-warning rounded-3 mt-4 mb-3 px-4 py-4">
                                  <div className="d-flex align-items-start gap-3">
                                    <div
                                      className="d-inline-flex flex-shrink-0 align-items-center justify-content-center rounded-circle bg-warning text-white"
                                      style={{ width: "36px", height: "36px" }}
                                      aria-hidden="true"
                                    >
                                      <strong className="fs-4">!</strong>
                                    </div>
                                    <div>
                                      <h5 className="fw-bold text-dark mb-2">
                                        Employee Not Eligible for Project Assignment
                                      </h5>
                                      <p className="mb-0 text-secondary">
                                        This employee does not have a Tech Stack configured.
                                        Please contact HR to update the employee&apos;s profile
                                        and enable project eligibility.
                                      </p>
                                    </div>
                                  </div>

                                  <hr className="my-3" />

                                  <div className="fw-bold text-dark mb-2">Notify HR</div>
                                  <div className="mb-3">
                                    {hrPocsLoading ? (
                                      <span className="text-muted">Loading HR POCs...</span>
                                    ) : hrPocs.length ? (
                                      hrPocs.map((poc) => (
                                        <div className="form-check mb-2" key={poc.id}>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`hr-poc-${poc.id}`}
                                            checked={selectedHrPocIds.includes(poc.id)}
                                            onChange={() => toggleHrPoc(poc.id)}
                                            disabled={notifyHrLoading || hrNotified}
                                          />
                                          <label
                                            className="form-check-label text-dark"
                                            htmlFor={`hr-poc-${poc.id}`}
                                          >
                                            {poc.name}
                                          </label>
                                        </div>
                                      ))
                                    ) : (
                                      <span className="text-muted">
                                        No HR POC configured
                                      </span>
                                    )}
                                  </div>
                                  <button
                                    type="button"
                                    className="btn theme-button px-4"
                                    onClick={notifyHrForTechStack}
                                    disabled={
                                      notifyHrLoading ||
                                      hrNotified ||
                                      selectedHrPocIds.length === 0
                                    }
                                  >
                                    <MdOutlineEmail className="me-2" aria-hidden="true" />
                                    {notifyHrLoading
                                      ? "Notifying..."
                                      : hrNotified
                                        ? "HR Team Notified"
                                        : "Notify Selected POCs"}
                                  </button>
                                  <small className="d-block text-muted mt-3">
                                    An email will be sent to the selected HR POCs with the
                                    employee details.
                                  </small>
                                </div>
                              ) : (
                                <>
                              {/* Project Expertise Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end">
                                    Project Expertise
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    placeholder={
                                      isExpertiseLoading
                                        ? "Loading Project Expertise"
                                        : "Select Project Expertise"
                                    }
                                    options={expertiseOptions}
                                    value={
                                      expertiseOptions.find(
                                        (option) => option.value === memberForm.expertise,
                                      ) || null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        expertise: option ? option.value : "",
                                      })
                                    }
                                    isLoading={isExpertiseLoading}
                                    isDisabled={isExpertiseLoading}
                                    isSearchable
                                    isClearable
                                  />
                                </div>
                              </div>

                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end has-asterisk">
                                    Joining Date
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <DatePicker
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="mm/dd/yyyy"
                                    selected={
                                      memberForm.joinDate
                                        ? new Date(memberForm.joinDate)
                                        : null
                                    }
                                    minDate={
                                      project?.sowStartDate
                                        ? new Date(project.sowStartDate)
                                        : null
                                    }
                                    maxDate={
                                      project?.sowEndDate
                                        ? new Date(project.sowEndDate)
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleDateChange(
                                        "joinDate",
                                        date ? format(date, "MM-dd-yyyy") : "",
                                      )
                                    }
                                    required
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="border"
                                    style={{
                                      borderColor: "#e1e5f7",
                                      borderRadius: "8px",
                                      padding: "10px 12px",
                                      fontSize: "15px",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* End Date */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end">
                                    End Date
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <DatePicker
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="mm/dd/yyyy"
                                    selected={
                                      memberForm.endDate
                                        ? new Date(memberForm.endDate)
                                        : null
                                    }
                                    minDate={
                                      memberForm.joinDate
                                        ? new Date(memberForm.joinDate)
                                        : project?.sowStartDate
                                          ? new Date(project.sowStartDate)
                                          : null
                                    }
                                    maxDate={
                                      project?.endDate
                                        ? new Date(project.endDate)
                                        : project?.sowEndDate
                                          ? new Date(project.sowEndDate)
                                          : null
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(date) =>
                                      handleDateChange(
                                        "endDate",
                                        date ? format(date, "MM-dd-yyyy") : "",
                                      )
                                    }
                                    className="border"
                                    style={{
                                      borderColor: "#e1e5f7",
                                      borderRadius: "8px",
                                      padding: "10px 12px",
                                      fontSize: "15px",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Status Row */}
                              <div className="row mb-3 align-items-center">
                                <div className="col-md-3">
                                  <label className="form-label mb-0 text-end">
                                    Status
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <Select
                                    options={StatusOptions}
                                    value={
                                      StatusOptions.find(
                                        (opt) =>
                                          opt.value === memberForm.status,
                                      ) || null
                                    }
                                    onChange={(option) =>
                                      setMemberForm({
                                        ...memberForm,
                                        status: option.value,
                                      })
                                    }
                                    placeholder="Select Status"
                                    isDisabled={true}
                                  />
                                </div>
                              </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer */}
                      <div
                        className="modal-footer rounded-lg-bottom"
                        style={{
                          backgroundColor: "#f8f9ff",
                          borderTop: "1px solid #e1e5f7",
                        }}
                      >
                        <button
                          type="button"
                          className="btn px-4 py-2"
                          onClick={closeMemberModal}
                          style={{
                            backgroundColor: "#6c757d",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn theme-button"
                          disabled={isLoading || selectedEmployeeRequiresTechStack}
                        >
                          {isLoading ? (
                            <ThreeDots
                              height="25"
                              width="80"
                              radius="9"
                              color="white"
                              ariaLabel="three-dots-loading"
                              visible={true}
                            />
                          ) : (
                            "Add Member"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            );
          }
        })()}

      {/* Footer */}
      {/* Delete Confirmation Modal */}
      <div
        className="modal fade"
        id="staticBackdropDependentDelete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content rounded-lg">
            <div className="modal-body">
              <h5 className="text-center">
                Are you sure you want to delete this member?
              </h5>
            </div>
            <div className="justify-content-center modal-footer">
              <button
                type="button"
                className={
                  isLoadingDelete ? "theme-button disabled" : "theme-button"
                }
                onClick={handleDelete}
              >
                {isLoadingDelete ? (
                  <ThreeDots
                    height="20"
                    width="53"
                    radius="9"
                    color="white"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                ) : (
                  "Yes"
                )}
              </button>
              <button
                type="button"
                className="theme-button bg-grey mx-3 w-35"
                data-bs-dismiss="modal"
                onClick={() =>
                  setDeleteTarget({ employeeId: null, projectId: null })
                }
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Deallocation Modal */}
      {showDeallocateModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content rounded-lg">
              <div className="modal-header">
                <h5 className="modal-title">Deallocate Member</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDeallocateModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Reason for Deallocation</label>
                <Select
                  options={dealocatedreasonOptions}
                  value={selectedReason}
                  onChange={(option) => setSelectedReason(option)}
                  placeholder="Select Reason"
                  disabled={!selectedReason}
                />
              </div>
              <div className="modal-footer rounded-lg-bottom">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowDeallocateModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn theme-button"
                  onClick={() => {
                    if (selectedReason) {
                      setShowDeallocateModal(false);
                      setShowConfirmDeallocateModal(true);
                    }
                  }}
                  disabled={!selectedReason}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Deallocation Confirmation Modal */}

      {showConfirmDeallocateModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content rounded-lg">
              <div className="modal-body">
                <h5 className="text-center">
                  Are you sure you want to deallocate this member?
                </h5>
              </div>
              <div className="modal-footer justify-content-center rounded-lg-bottom">
                <button
                  type="button"
                  className={
                    isLoading && showConfirmDeallocateModal
                      ? "theme-button disabled"
                      : "theme-button"
                  }
                  onClick={handleDeallocateConfirm}
                >
                  {isLoading ? (
                    <ThreeDots
                      height="20"
                      width="53"
                      radius="9"
                      color="white"
                      ariaLabel="three-dots-loading"
                      visible={true}
                    />
                  ) : (
                    "Yes"
                  )}
                </button>
                <button
                  type="button"
                  className="theme-button bg-grey mx-3 w-35"
                  onClick={() => setShowConfirmDeallocateModal(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <ProjectCompleteNotificationModal
        show={showProjectCompletedModal}
        onConfirm={handleCompleteConfirm}
        onCancel={handleCompleteCancel}
        isLoading={isLoadingCompletedProject}
      />

      <ProjectHoldToActiveModal
        show={showHoldToActiveModal}
        onConfirm={handleHoldToActiveConfirm}
        onCancel={handleHoldToActiveCancel}
        isLoading={holdToActiveLoading}
        project={
          projectList.find((p) => p.id === pendingHoldToActiveProjectId) || {}
        }
      />

      <LeadershipEffectiveDateModal
        show={Boolean(leadershipDateRequest)}
        changes={leadershipDateRequest?.changes || []}
        project={projectList.find((p) => p.id === leadershipDateRequest?.projectId) || {}}
        onCancel={() => setLeadershipDateRequest(null)}
        onConfirm={(dates) => {
          const request = leadershipDateRequest;
          setLeadershipDateRequest(null);
          if (request) void handleUpdateProject(request.projectId, null, request.sendNotification, request.withHoldToActiveDate, request.holdToActiveDate, dates);
        }}
      />

      <Footer />
    </div>
  );
}

export default ProjectList;
